import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 px-6 bg-carbon-light border-t border-carbon-lighter relative overflow-hidden" data-id="element-84">
      {/* Radial gradient background accent */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(242,183,5,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-85" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center relative z-10" data-id="element-86">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-10 text-balance" data-id="element-87">
          Deja de depender de la temporada. <br data-id="element-88" />
          <span className="text-gold" data-id="element-89">Empieza a cobrar todos los meses.</span>
        </h2>

        <div className="flex flex-col items-center" data-id="element-90">
          <a href="#contact-form" className="group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-dark text-carbon font-heading font-bold text-lg md:text-2xl px-10 py-6 rounded-xl transition-all duration-300 animate-cta-glow hover:scale-105 active:scale-95 w-full md:w-auto shadow-2xl" data-id="element-91">
            <span data-id="element-92">QUIERO CONTRATOS RECURRENTES AHORA</span>
            <ArrowDownIcon className="w-6 h-6 group-hover:translate-y-1 transition-transform" data-id="element-93" />
          </a>

          <div className="mt-6 text-center" data-id="element-94">
            <p className="text-neutral-400 font-body text-sm mb-2" data-id="element-95">
              Diagnóstico gratuito en 15 minutos.
            </p>
            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-dark underline underline-offset-4 font-body text-sm transition-colors" data-id="element-96">
              O haz tu cita directamente en nuestro calendario aquí
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}